<template>
  <EditModal @close="close" @commit="commit" :lang="lang" class="modal-edit-case">
    <div class="modal-edit-case-container">
      <BaseButton5 @click="create" class="modal-edit-case-create" :type="2">+ 添加案例</BaseButton5>
      <div v-for="(row, i) in input" :key="i" class="modal-edit-case-media">
        <div v-if="row.type==='media'">
          <div class="modal-edit-case-media-control">
            <IconButton v-if="i > 0" @click="moveUp(row, i)" class="icon-dc_phone_icon_email_up"></IconButton>
            <IconButton v-if="i < input.length - 1" @click="moveDown(row, i)" class="icon-pr_phone_arrow_edit_open"></IconButton>
            <IconButton @click="remove(row, i)" class="icon-dc_phone_icon_email_delete"></IconButton>
          </div>
          <div class="modal-edit-case-media-content">
            <UploadButton class="upload"
              @click="upload(row, i)" :src="row.img || row.imgForAvatar"></UploadButton>
            <input
              :id="`page-edit-case-media-upload-${i}`"
              class="invisible" type="file" accept="*/*"
              :data-index="i"
              @change="updateImg">
            <div class="modal-edit-case-media-content-right" style="z-index:1">
              <div class="modal-edit-case-media-content-right-name">
                <div class="modal-edit-case-media-title">
                  <span class="red">*</span>项目名称
                </div>
                <div class="modal-edit-case-media-content-right-input">
                  <BaseInput
                    height="36px" width="367px"
                    :maxlength="32"
                    v-model.trim="row.name"></BaseInput>
                </div>
              </div>
              <div class="modal-edit-case-media-content-right-label">
                <div class="modal-edit-case-media-title">
                  <span class="red">*</span>行业
                </div>
                <div>
                  <BaseInput
                    height="36px" width="367px"
                    v-model.trim="row.label"
                    :placeholder="lang.industry"
                    :maxlength="32"
                    icon="icon-pr_phone_arrow_edit_open" iconFloat="right"
                    @icon="clickDesc(i)"
                  ></BaseInput>
                </div>
                <TagDropdown v-if="showTagDropdown===i"
                  maxHeight="125px"
                  @close="showTagDropdown=-1"
                  @click="updateIndustry"
                  :value="row.label"
                  :index="i"
                  :data="config.industry"
                ></TagDropdown>
              </div>
            </div>
          </div>
          <div class="modal-edit-case-media-desc">
            <div class="modal-edit-case-media-title">项目描述</div>
            <div class="desc">
              <textarea
                :maxlength="1000"
                v-model.trim="row.value"
                height="72px" width="540px"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </EditModal>
</template>

<script>
import _ from 'lodash'

import EditModal from './EditModal.vue'

import { BaseInput } from '../input'
import {
  BaseButton5,
  IconButton,
  UploadButton
} from '../button'
import { TagDropdown } from '../dropdown'

export default {
  components: {
    EditModal,
    BaseInput,
    BaseButton5,
    IconButton,
    UploadButton,
    TagDropdown
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      lang: {
        title: `编辑${this.data.name}`,
        industry: '选择或输入项目所属行业'
      },
      input: _.cloneDeep(this.data.value),
      defaultData: {
        type: 'media',
        name: '',
        value: '',
        label: ''
      },
      showTagDropdown: -1
    }
  },
  methods: {
    clickDesc (i) {
      if (this.showTagDropdown < 0) {
        this.showTagDropdown = i
      } else if (this.showTagDropdown !== i) {
        this.showTagDropdown = i
      } else {
        this.showTagDropdown = -1
      }
    },
    /**
     * 上传图片相关
     */
    upload (row, i) {
      document.getElementById(`page-edit-case-media-upload-${i}`).click()
    },
    async updateImg (event) {
      let file = event.target.files[0]
      this.$store.dispatch('checkFile', {file})
      let data = await this.$store.dispatch('api/dartcome/createUserImage', {file})
      let i = parseInt(event.target.getAttribute('data-index'))
      this.input[i].logo = data
      this.input[i].img = this.input[i].logo.url
      this.input[i].imgFile = file
      let reader = new FileReader()
      reader.onload = e => {
        this.input[i].imgForAvatar = e.target.result
        this.input.splice(i, 1, this.input[i])
      }
      reader.readAsDataURL(file)
    },
    updateIndustry (row, i, ii) {
      this.input[ii].label = row.label
      this.showTagDropdown = -1
    },
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    create () {
      this.input.unshift(_.cloneDeep(this.defaultData))
    },
    remove (row, i) {
      this.input.splice(i, 1)
    },
    move (fromIndex, toIndex) {
      let row = this.input.splice(fromIndex, 1)[0]
      this.input.splice(toIndex, 0, row)
    },
    moveUp (row, i) {
      this.move(i, i - 1)
    },
    moveDown (row, i) {
      this.move(i, i + 1)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.modal-edit-case {
  & .modal-edit-case-container {
    max-height: 400px;
    padding: 10px 30px;
    overflow: auto;
    & .modal-edit-case-create {
      margin-top: 22px;
    }
    & .modal-edit-case-media {
      position: relative;
      & .modal-edit-case-media-control {
        position: absolute;
        top: 0;
        right: 0;
        & .modal-edit-case-media-control-icon {
          height: calc(28px - 6px * 2 - 1px * 2);
          width: calc(28px - 6px * 2 - 1px * 2);
        }
      }
      & .modal-edit-case-media-content {
        padding-top: calc(20px + 28px);
        padding-bottom: 20px;
        & .upload {
          height: 133px;
          width: 133px;
          display: inline-block;
        }
        & .modal-edit-case-media-content-right {
          position: absolute;
          display: inline-block;
          width: 367px;
          margin-left: calc(540px - 133px - 367px);

          & .modal-edit-case-media-content-right-name {
            padding-bottom: 7px;
          }

          & .modal-edit-case-media-content-right-label {
            padding-top: calc(21px - 7px - 2px);
          }

          & .red {
            color: var(--colorError);
          }
          & .modal-edit-case-media-content-right-input {
          }
        }
      }
      & .modal-edit-case-media-desc {
        padding-bottom: 40px;

        & .desc {
          position: relative;
          padding: 11px 15px;
          width: 540px;
          height: 80px;
          border: 1px solid var(--colorDisabled);
          border-radius:2px;
          box-sizing: border-box;
          overflow: hidden;

          & textarea {
            resize: none;
            position: relative;
            outline: none;
            height: 100%;
            width: 100%;
            padding: 0;
            border: 0;
            @media (--mediaPc) {
              font-size: 14px;
            }
            @media (--mediaMobile) {
              font-size: var(--textSize3Mobile);
            }
          }
        }
      }
      & .modal-edit-case-media-title {
        padding-bottom: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/EditCaseModal.vue